var autoPan =
webpackJsonp_name_([10],{

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(547);

__webpack_require__(377);

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AutoPan = AutoPan;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _objects = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AutoPan(uScope, viewport) {
    // improvemetns:
    //    - instead of moving the div offscreen I could use show/hide like all the other overlays!
    var self = this;
    var isLoaded = false;

    var jVpDiv = viewport.vpDivGet('outer');
    var jAutoPan;

    var timerId = -1; // the autopan timer id

    var autoPanSpecs = { //    autopan settings
        'timerInterval': 50, // timer interval in milliseconds
        'speedFactor': 8, // speed factor - larger number slows pan speed
        'autoPanLT': undefined, // left-top location of center target, Point type, initially undefined
        autoPanCursor: 'url(/viewer/uScope/images/autopan-cur.png), url(/viewer/uScope/images/autopan-cur.cur), auto',
        autoPanCursorOffset: 16 // the hotspot on a cursor is not working so this hard coded offset is used
    };

    //............................................ off() public
    //    This functions turnsoff autopan.
    this.off = function () {
        if (viewport.navModeGet() == _defines2.default.eNavModes.nmAutoPan) self.onOffToggle();
    };

    //............................................ onOffToggle() public
    //    This function toggles autopan on/off.
    this.onOffToggle = function () {
        if (jAutoPan.length == 0) return; // if no match was found, return
        if (isLoaded == false) return;

        // Stop auto-pan when readOnly attribute for a plugin (VP) is true.
        var vpView = viewport.getVPView();
        if (!vpView.isReadOnly && viewport.navModeGet() != _defines2.default.eNavModes.nmAutoPan) {
            // if not autopanning, start autopan
            if (autoPanSpecs.autoPanLT === undefined) // place the autopan image/symbol in the center of the view
                autoPanSpecs.autoPanLT = new _objects.Point();

            var vpDivDims = viewport.vpDivDimsGet();
            autoPanSpecs.autoPanLT.x = Math.round((vpDivDims.w - jAutoPan.width()) / 2);
            autoPanSpecs.autoPanLT.y = Math.round((vpDivDims.h - jAutoPan.width()) / 2);
            jAutoPan.css({ 'left': autoPanSpecs.autoPanLT.x + 'px', 'top': autoPanSpecs.autoPanLT.y + 'px' });

            jVpDiv.addClass(_defines2.default.clsAPANCUR); // set the autopan cursor
            viewport.navModeSwitch(_defines2.default.eNavModes.nmAutoPan); // set autopan nav mode
            timerId = setInterval(function () {
                _timer();
            }, autoPanSpecs.timerInterval);
        } else {
            // if autopanning, halt autopan navigation
            // note: this is called from navmodehalt so do not call back to it!

            clearInterval(timerId); // stop the autopan timer
            timerId = -1;
            jVpDiv.removeClass(_defines2.default.clsAPANCUR); // return to auto cursor

            // place the autopan image/symbol offscreen//cp-is this better than hiding it?
            jAutoPan.css({ 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX });
        }
    };

    //    This function loads the autopan center-of-the-view image.
    self.init = function () {
        if (jAutoPan) return; // if this viewport already has a autopan div, return

        // first create an offscreen div that will contain the autopan image and add it to the vp
        jAutoPan = $('<div/>', { // build the div tag that contains the img tag
            'class': _defines2.default.clsAPANDIV + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX } // locate offscreen
        });
        jVpDiv.append(jAutoPan); // place the autopan div in the vp
        jAutoPan = jVpDiv.find('.' + _defines2.default.clsAPANDIV); // save for quick access
        isLoaded = true;

        bindEvents_();
    };

    function bindEvents_() {
        var namespace = '.autopan';
        $(_defines2.default.idHashROOT).on('click' + namespace, '#' + _defines2.default.idTOPTOOLBARV, function (e) {
            self.onOffToggle();
            return false;
        });

        // TODO: Autopan
        viewport.events.on('viewport:before-zoom-absolute', self.off);
        viewport.events.on('viewport:stop-navigation', function (navMode) {
            if (navMode === _defines2.default.eNavModes.nmAutoPan) {
                self.off();
                return true;
            }
        });
        viewport.events.on('state-readonly:change', function (isReadOnly) {
            if (isReadOnly) {
                self.off();
            }
        });
    }

    //............................................ _timer() local
    //    This function moves the view in proportion to the distance between the cursor and view center.
    var _timer = function _timer() {
        if (viewport.navModeGet() == _defines2.default.eNavModes.nmAutoPan) {
            // move the image proportional to the distance between the cursor and view center
            var offset = autoPanSpecs.autoPanCursorOffset; // html/js seems to ignore cursor hotspots
            var ptMouse = viewport.getMouseCur();
            var cx = ptMouse.x + offset; // so add offset to correct it
            var cy = ptMouse.y + offset; // so add offset to correct it

            var vpDivDims = viewport.vpDivDimsGet();
            var speedFactor = autoPanSpecs.speedFactor; // move the image dx, dy
            var dx = (cx - vpDivDims.w / 2) / viewport.getViewZoom() / speedFactor;
            var dy = (cy - vpDivDims.h / 2) / viewport.getViewZoom() / speedFactor;
            viewport.moveRelative(dx, dy, _defines2.default.coordSystemNORM);

            // rotate the autopan autopan center target to point to the cursor
            // - note that the icon's arrow is at 45 degrees so correct for that
            var apAngleDeg = -Math.round(Math.atan2(-dy, dx) * _defines2.default.Rad2Deg);
            var strAngle = apAngleDeg + 45 + viewport.getViewAngle(true) + 'deg';
            jAutoPan.css({
                'transform': 'rotate(' + strAngle + ')',
                'ms-transform': 'rotate(' + strAngle + ')', /* Internet Explorer  note that the leading '-' is removed */
                '-moz-transform': 'rotate(' + strAngle + ')', /* Firefox */
                '-webkit-transform': 'rotate(' + strAngle + ')', /* Safari and Chrome */
                '-o-transform': 'rotate(' + strAngle + ')' /* Opera */
            });
        } else {
            // stop this timer!  shouldn't ever happen
            // ('Warning: autopan:_timer: But not in autopan mode - Halting Navigation' + viewport.getImageId()); // eslint-disable-line no-undef
            viewport.navModeHalt();
        }
    };
}

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EdgeNav = EdgeNav;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EdgeNav(uScope, viewport, autoPan) {
    var self = this;

    var jVpDiv = viewport.vpDivGet('outer');
    var jEdgeNavDivs = void 0;

    var edgeNavSpecs = {
        dim: 29
    };

    /**
     * This function positions and sizes the edge navigation divs in the viewport.
     */
    this.resize = function () {
        var vpDivDims = viewport.vpDivDimsGet();
        var w = vpDivDims.w;
        var h = vpDivDims.h;
        var dim = edgeNavSpecs.dim;

        for (var i = 0; i < jEdgeNavDivs.length; i++) {
            var jEdgeNavDiv = jEdgeNavDivs.eq(i);
            var side = jEdgeNavDiv.attr('side');

            if (side == 'left') jEdgeNavDiv.css({ 'left': 0, 'top': 0, 'width': dim, 'height': h });else if (side == 'right') jEdgeNavDiv.css({ 'left': w - dim, 'top': 0, 'width': dim, 'height': h });else if (side == 'top') jEdgeNavDiv.css({ 'left': 0, 'top': 0, 'width': w, 'height': dim });else if (side == 'bottom') jEdgeNavDiv.css({ 'left': 0, 'top': h - dim, 'width': w, 'height': dim });
        }
    };

    /**
     * This function creates and adds the edge navigation divs to the viewport.
     */
    self.init = function () {
        if (jEdgeNavDivs) {
            return;
        }

        var template = ['top', 'left', 'right', 'bottom'].map(function (side) {
            return '<div class="' + _defines2.default.clsEDGEDIV + ' ' + _defines2.default.clsOVERLAY + '" side="' + side + '"></div>';
        }).join('\n');

        jEdgeNavDivs = $(template);
        jVpDiv.append(jEdgeNavDivs);

        self.resize();

        jEdgeNavDivs.on('click', function (e) {
            autoPan.onOffToggle();
            return false;
        });

        viewport.events.on('viewport:resize', self.resize);
    };
}

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _AutoPan = __webpack_require__(375);

var _EdgeNav = __webpack_require__(376);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_publicApi2.default.plugins.register({
    name: 'us:auto-pan',

    extends: 'viewport',

    canStart: function canStart() {
        return _defines2.default.ENABLEAUTOPAN;
    },


    constructor: function constructor(uScope, viewport) {
        var autoPan = new _AutoPan.AutoPan(uScope, viewport);
        var en = new _EdgeNav.EdgeNav(uScope, viewport, autoPan);

        autoPan.init();
        en.init();

        // HACK ALERT. Can't remove due to use in events.js
        viewport.autoPan = autoPan;
    }
});

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(328);


/***/ })

},[612]);